import * as React from 'react'

import styled from '@emotion/styled'

import { ArcadeIcon } from '@arcade/web/icons/react'
import { spacing, Stack } from '@cash-design-system/react'

import { TextElement } from '../FormBlocker/elements'

const IconWrapper = styled.div`
  align-items: center;
  color: ${props => props.theme.colors.icon};
  height: 1em;
  justify-content: center;
  width: 1em;
`

const ListWrapper = styled.ul`
  display: grid;
  padding: 0 0.5rem;
  row-gap: ${spacing.l};
`

const ListItemWrapper = styled.li`
  color: ${props => props.theme.colors.secondaryLabel};
  column-gap: ${spacing.m};
  display: grid;
  grid-template-columns: 1.5rem auto;
  ${props => props.theme.typography.bodyDefault};
`

type IconType = ArcadeIcon<16 | 24> | ArcadeIcon<16 | 24 | 32>

const ListItem = ({ Icon, children }: { Icon: IconType; children: React.ReactNode }) => (
  <ListItemWrapper>
    <IconWrapper>
      <Icon size={24} />
    </IconWrapper>
    {children}
  </ListItemWrapper>
)

type IconListItem = { Icon: IconType; title: string; description: string }

export const TotpIconList = ({ items }: { items: IconListItem[] }) => {
  return (
    <ListWrapper>
      {items.map(({ Icon, title, description }, i) => (
        <ListItem Icon={Icon} key={i}>
          <Stack space={spacing.xs}>
            <TextElement text={title} removeTextPadding={true} />
            <TextElement text={description} removeTextPadding={true} />
          </Stack>
        </ListItem>
      ))}
    </ListWrapper>
  )
}
